import { adminServerInstance, deliveryServerInstance } from "../axios/instances";
import axios from "axios";
import { BASIC_INFO_LOAD, BASIC_INFO_LOAD_SUCCESS, BASIC_INFO_LOAD_FAIL } from './driverTypes.js';
import { WORKING_AREA_LOAD, WORKING_AREA_LOAD_SUCCESS, WORKING_AREA_LOAD_FAIL } from './driverTypes.js';
import { DRIVER_LIST_LOAD, DRIVER_LIST_LOAD_SUCCESS, DRIVER_LIST_LOAD_FAIL } from './driverTypes.js';
import { DRIVER_INFO_LOAD, DRIVER_INFO_LOAD_SUCCESS, DRIVER_INFO_LOAD_FAIL } from './driverTypes.js';
import { HANDLE_ADD_EDIT_DRIVER_DIALOG } from './driverTypes.js';
import { DRIVER_INFO_ADD, DRIVER_INFO_ADD_SUCCESS,  DRIVER_INFO_ADD_FAIL } from './driverTypes.js';
import { DRIVER_INFO_UPDATE, DRIVER_INFO_UPDATE_SUCCESS,  DRIVER_INFO_UPDATE_FAIL } from './driverTypes.js';
import { DRIVER_SALARY_TYPE_FIX_LOAD, DRIVER_SALARY_TYPE_FIX_LOAD_SUCCESS, DRIVER_SALARY_TYPE_FIX_LOAD_FAIL } from './driverTypes.js';
import { GET_TEAM_LIST, GET_TEAM_LIST_SUCCESS, GET_TEAM_LIST_FAIL } from './driverTypes.js';
import { ADD_NEW_DRIVER_TEAM, ADD_NEW_DRIVER_TEAM_SUCCESS, ADD_NEW_DRIVER_TEAM_FAIL } from './driverTypes.js';
import { HANDLE_DRIVER_ID } from './driverTypes.js';
import { LOG_DRIVER_OPERATIONS, LOG_DRIVER_OPERATIONS_SUCCESS, LOG_DRIVER_OPERATIONS_FAIL } from './driverTypes.js';
import { CREATE_AGENT_DRIVERS, CREATE_AGENT_DRIVERS_SUCCESS, CREATE_AGENT_DRIVERS_FAIL } from './driverTypes.js';


export function handleDriverId(id) {
    return function(dispatch){
        dispatch({type: HANDLE_DRIVER_ID})
        return (
            dispatch({
                type: HANDLE_DRIVER_ID,
                payload:id
            })
        )}
}

export function editDriverAddress(address) {
    return function() {
        return adminServerInstance.post(`/map/editdriveraddress`, {
            address: address
        })
        .then(({data}) => {
            return Promise.resolve(data.data);
        }).catch(error => {
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.criteria
 * @param {string} params.warehouse_id
 * @param {string} params.start_date
 * @param {string} params.end_date
 * @param {string} params.data_type
 */
export function getDriverOperations(params) {
    return function(dispatch) {
        dispatch({type: LOG_DRIVER_OPERATIONS})
        return deliveryServerInstance.get(`/log/driver/operations`, {params: params})  
        .then(({data}) => {
            dispatch({
                type: LOG_DRIVER_OPERATIONS_SUCCESS,
                payload: data.biz_data,
            })    
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type:  LOG_DRIVER_OPERATIONS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getBasicInfo() {
    return function(dispatch) {
        dispatch({type: BASIC_INFO_LOAD})
        return adminServerInstance.get(`map/getbasicinfo`)  
        .then(({data}) => {
            dispatch({
                type: BASIC_INFO_LOAD_SUCCESS,
                payload: data,
            })    
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type:  BASIC_INFO_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getWorkingArea() {
    return function(dispatch) {
        dispatch({type: WORKING_AREA_LOAD})
        return adminServerInstance.get(`map/getworkingarea?city_id=1`)  
        .then(({data}) => {            
            dispatch({
                type: WORKING_AREA_LOAD_SUCCESS,
                payload: data,
            })    
            return Promise.resolve();
        }).catch(error => {
            dispatch({
                type:  WORKING_AREA_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function addNewDriverTeam(team_name, city_id, name_alias) {
    return function(dispatch) {
        dispatch({type: ADD_NEW_DRIVER_TEAM})
        return adminServerInstance.post(`/driver/addnewdriverteam`, {
            team_name: team_name,
            city_id: city_id,
            team_name_alias: name_alias
        })  
        .then(({data}) => {            
            dispatch({
                type: ADD_NEW_DRIVER_TEAM_SUCCESS,
                payload: data,
            })    
            return Promise.resolve();
        }).catch(error => {
            dispatch({
                type:  ADD_NEW_DRIVER_TEAM_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getTeamList(city) {
    return function(dispatch) {
        dispatch({type: GET_TEAM_LIST})
        return adminServerInstance.get(`/driver/getdriverteams?city_id=${city}`)  
        .then(({data}) => {            
            dispatch({
                type: GET_TEAM_LIST_SUCCESS,
                payload: data,
            })    
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type:  GET_TEAM_LIST_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getDriverList(params /** page and size cann't be bypass*/) {
    let queryCondition = "/map/getalldrivers?";
    for (let key in params) {
        queryCondition = queryCondition + (key + "=" + params[key]) + "&";            
    }
    let lastIndex = queryCondition.lastIndexOf("&");
    queryCondition = queryCondition.substring(0,lastIndex);
    return function(dispatch) {    
        dispatch({type: DRIVER_LIST_LOAD})
        return adminServerInstance.get(queryCondition)
        .then(({data}) => {
            dispatch({
                type: DRIVER_LIST_LOAD_SUCCESS,
                payload: data.data,
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type:  DRIVER_LIST_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getSalaryTypeFixList() {
    return function(dispatch) {
        dispatch({type: DRIVER_SALARY_TYPE_FIX_LOAD})
        return adminServerInstance.get(`/map/getsalarytype`)
        .then(({data}) => {
            dispatch({
                type: DRIVER_SALARY_TYPE_FIX_LOAD_SUCCESS,
                payload: data.data.driver_data,
            })
            return Promise.resolve();
        }).catch(error => {
            dispatch({
                type:  DRIVER_SALARY_TYPE_FIX_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

/**
 * 
 * @param {*} driverId 
 * @param {*} cityId 
 * @returns 
 */
export function getDriverById(driverId=3,cityId=1) {
    return function(dispatch) {
        dispatch({type: DRIVER_INFO_LOAD})
        return adminServerInstance.get(`/map/getdriverbyid?driver_id=${driverId}&city_id=${cityId}`)
        .then(({data}) => {
            dispatch({
                type: DRIVER_INFO_LOAD_SUCCESS,
                payload: data.data
            })
            return Promise.resolve();
        }).catch(error => {
            dispatch({
                type:  DRIVER_INFO_LOAD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

/**
 * @param {int} params.userId 
 * @param {int} params.userCity 
 * @param {file} params.file
 */
export function createAgentDriver(params) {  
    return function(dispatch) {
        dispatch({type: CREATE_AGENT_DRIVERS})
        return axios.post(`${process.env.REACT_APP_MAP_SERVER_URL}/map/createagentdrivers`, params,{
            responseType: 'blob',
            timeout: 0
        })
        .then((response) => {
            dispatch({
                type: CREATE_AGENT_DRIVERS_SUCCESS,
                payload: response
            })
            if (response.headers['content-type'] === "application/json"){
                return Promise.resolve(response);
            } else {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `DriversList.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                return Promise.resolve(response);
            }
        })
        .catch((error) => {
            dispatch({
                type: CREATE_AGENT_DRIVERS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}
/**
 * control the add/edit dirver dialog
 * @param {} isOpen 
 */
 export function handleAddEditDriverDialog(isOpen, type) {
    return function(dispatch) {
        dispatch({
            type: HANDLE_ADD_EDIT_DRIVER_DIALOG,
            payload: {
                open: isOpen,
                openType: type
            },
        })
    }
}

/**
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.city 
 * @param {string} params.district
 * @param {Number} params.number
 */
export function addSystemDrivers(parmas) {
    return function(dispatch) {
        dispatch({type: DRIVER_INFO_ADD})
        return adminServerInstance.post(`/map/addsystemdrivers`,parmas)
        .then(({data}) => {
            dispatch({
                type: DRIVER_INFO_ADD_SUCCESS,
                payload: data,
            })    
            return Promise.resolve();
        }).catch(error => {
            dispatch({
                type:  DRIVER_INFO_ADD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

/**
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.role 
 * @param {string} params.city_id
 * @param {string} params.name
 * @param {string} params.gender 
 * @param {string} params.lastname
 * @param {string} params.firstname
 * @param {string} params.phone 
 * @param {string} params.workingarea
 * @param {string} params.sin
 * @param {string} params.address 
 * @param {string} params.city_id
 * @param {string} params.entry_time
 * @param {string} params.resignation_time 
 * @param {string} params.supplies
 * @param {string} params.bossflg
 * @param {Array} params.group 
 * @param {Array} params.salary_type
 * @param {Number} params.is_hired
 * @param {string} params.role_desc 
 * @param {string} params.devicetoken
 * @param {string} params.password // '7777'
 * @param {Number} params.workingstatus // 0
 * @param {string} params.username
 * @param {Number} params.level // 1
 * @param {Number} params.resignation_time // 0
 */
export function addDriverInfo(parmas) {
    return function(dispatch) {
        dispatch({type: DRIVER_INFO_ADD})        
        return adminServerInstance.post(`/map/adddriver`,parmas)
        .then(({data}) => {
            dispatch({
                type: DRIVER_INFO_ADD_SUCCESS,
                payload: data,
            })    
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: DRIVER_INFO_ADD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

/**
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.role 
 * @param {string} params.city_id
 * @param {string} params.name
 * @param {string} params.gender 
 * @param {string} params.lastname
 * @param {string} params.firstname
 * @param {string} params.phone 
 * @param {string} params.workingarea
 * @param {string} params.sin
 * @param {string} params.address 
 * @param {string} params.city_id
 * @param {string} params.entry_time
 * @param {string} params.resignation_time 
 * @param {string} params.supplies
 * @param {string} params.bossflg
 * @param {Array} params.group 
 * @param {Array} params.salary_type
 * @param {Number} params.is_hired
 * @param {string} params.role_desc 
 * @param {string} params.devicetoken
 * @param {string} params.password // '7777'
 * @param {Number} params.workingstatus // 0
 * @param {string} params.username
 * @param {Number} params.level // 1
 * @param {Number} params.resignation_time // 0
 */
export function updateDriverInfo(parmas) {
    return function(dispatch) {
        dispatch({type: DRIVER_INFO_UPDATE})
        return adminServerInstance.post(`/map/editdriver`,parmas)
        .then(({data}) => {
            dispatch({
                type: DRIVER_INFO_UPDATE_SUCCESS,
                payload: data,
            })
        return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type:  DRIVER_INFO_UPDATE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getPredefinedDriverNote(orderId){
    return function(dispatch){
        // dispatch({type: GET_PREDEFINED_DRIVER_NOTE})
        return adminServerInstance.get(`/map/getpredefineddrivernotes`, {
                params: {
                    order_id: orderId
                }
            }).then(({data}) => {
                // dispatch({
                //     type: GET_PREDEFINED_DRIVER_NOTE_SUCCESS,
                //     payload: data.data
                // })
                return Promise.resolve(data.data);
            }).catch(error => {
                // dispatch({
                //     type: GET_PREDEFINED_DRIVER_NOTE_FAIL,
                //     payload: error
                // })
                return Promise.reject(error);
            })
    }
}